import { useId } from 'react';

/**
 * Edits the "document" token-count param either by number of pages or by
 * characters, keeping both in sync (pages × pageTokens = document tokens).
 */
export function DocumentRow({
	label,
	tokens,
	pageTokens,
	charsPerToken,
	onChange,
}: {
	label: string;
	tokens: number;
	pageTokens: number;
	charsPerToken: number;
	onChange: (tokens: number) => void;
}) {
	const charsId = useId();
	const pagesId = useId();
	const characters = Math.round(tokens * charsPerToken);
	const pages = pageTokens > 0 ? Math.round((tokens / pageTokens) * 100) / 100 : 0;
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: 10,
				marginBottom: 6,
			}}
		>
			<label htmlFor={charsId} style={{ fontSize: 12, color: '#111' }}>
				{label}
			</label>
			<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
				<input
					id={pagesId}
					type="number"
					min={1}
					step={1}
					value={pages}
					onChange={(e) => {
						// Accept any page count (incl. fractional); document tokens = pages × page tokens.
						const p = Number(e.target.value);
						if (Number.isFinite(p) && p > 0) onChange(p * pageTokens);
					}}
					aria-label={`${label} pages`}
					style={{
						width: 56,
						fontSize: 13,
						padding: '4px 6px',
						border: '.5px solid #ddd',
						borderRadius: 6,
						textAlign: 'right',
						boxSizing: 'border-box',
					}}
				/>
				<span style={{ fontSize: 10, color: '#888' }}>pages</span>
				<input
					id={charsId}
					type="number"
					min={1}
					step={1}
					value={characters}
					onChange={(e) => {
						// Store the exact character count as tokens (chars ÷ charsPerToken) so any
						// value is accepted — no snapping to multiples of charsPerToken.
						const c = Math.max(1, Math.round(Number(e.target.value) || 1));
						onChange(c / charsPerToken);
					}}
					aria-label={`${label} characters`}
					style={{
						width: 72,
						fontSize: 13,
						padding: '4px 6px',
						border: '.5px solid #ddd',
						borderRadius: 6,
						textAlign: 'right',
						boxSizing: 'border-box',
					}}
				/>
				<span style={{ fontSize: 10, color: '#888' }}>chars</span>
				<span style={{ fontSize: 11, color: '#111', fontWeight: 600, minWidth: 72, textAlign: 'right' }}>
					≈ {(Math.round(tokens * 100) / 100).toLocaleString()} tokens
				</span>
			</div>
		</div>
	);
}
